export enum LoanStudyStatus {
  AccountSelection = 'ACCOUNT_SELECTION',
}
